export const accent = '#c69f73';
